import i18n from "i18next";

export { T } from "./t";
export { useTranslation } from "react-i18next";
export {
  ALL_LOCALES,
  DEFAULT_LOCALE,
  getLocaleName,
  localeMatchesSearch,
  searchLocales,
} from "./locales";
export type { Locale } from "./locales";
export { LocalizationProvider } from "./localization-provider";
export { ALL_PLURAL_SUFFIXES, getPluralForms } from "./plurals";
export type { PluralSuffix } from "./plurals";
export type { I18nBundle } from "./resources";

export function t(
  key: string,
  options?: Record<string, unknown>,
): string {
  return i18n.t(key, options);
}
